import React, {useContext, useState} from 'react';
// materialUI imports
import {Box, Typography} from '@mui/material';

// project imports
import CustomFormField from "../ui-component/CustomFormField";
import APIRequestButton from "../ui-component/extended/APIRequestButton";
import {useAuthHeaders} from "./AuthHeaders";
import ApiUrlContext from "../ApiUrlContext";
import {ResponseDisplay} from "./response/ResponseDisplay";
import {AuthContext, handleRemoveLocalStorage} from "./auth/AuthContext";
// 3rd Party imports
import axios from 'axios';
import * as Yup from 'yup';
import {Form, Formik} from 'formik';

// ============================|| Query - Debit ||============================ //

const DebitQuerySection = () => {
        const [response, setResponse] = useState(null);
        const apiUrl = useContext(ApiUrlContext);
        const {setIsAuthenticated} = useContext(AuthContext);
        const authHeaders = useAuthHeaders();

        const handleSubmit = async (values) => {
            const requestData = {
                debitReference: values.debitReference,
            };

            try {
                const response = await axios.post(`${apiUrl}/query`, requestData, {
                    headers: authHeaders,
                });
                console.log('Response:', response.data);
                setResponse(response.data);
            } catch (error) {
                if (error.response && error.response.data.error.code === "401") {
                    // Handle 401 Unauthorized response
                    setIsAuthenticated(false);
                    handleRemoveLocalStorage();
                }
            }
        };

        return (
            <Box mt={2}>
                <Typography variant="h6" component="h2" gutterBottom>
                    Query debit - Please enter the debit ID
                </Typography>

                <Formik
                    initialValues={{
                        debitReference: '',
                    }}
                    validationSchema={Yup.object().shape({
                        debitReference: Yup.string().required('debit ID is required'),
                    })}
                    onSubmit={handleSubmit}
                >
                    {({values, handleChange, handleBlur, handleSubmit, isSubmitting, touched, errors}) => (
                        <Form onSubmit={handleSubmit}>
                            <CustomFormField
                                name="debitReference"
                                label="Debit Reference"
                                value={values.debitReference}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                touched={touched}
                                errors={errors}
                            />
                            <APIRequestButton isSubmitting={isSubmitting}/>
                        </Form>
                    )}
                </Formik>


                {response && (
                    <Box mt={2}>
                        <ResponseDisplay response={response}/>
                    </Box>
                )}
            </Box>
        );
    }
;

export default DebitQuerySection;